import { Section } from './section';

/**
 * Represents a chapter inside a book
 */
export interface Chapter {
    /**
     * Title of a chapter
     */
    title: string;
    /**
     * Section ('Abschnitt') e.g.:
     * A. Allgemeines
     * B. Informationspflichten – §§ 13 bis 15 SGB I
     *      I) Allgemeines
     *      ...
     *      II) Beratung – § 14 SGB I
     *        1. Allgemeines
     * C. Der sozialrechtliche Herstellungsanspruch
     */
    sections: Section[];

    /**
     * Percentage of subNodes which are read
     */
    progress?: number;

    /**
     * time in Seconds that has been read, accumulated over the children
     */
    timeRead?: number;

    /**
     * an identifier which article of the FAO is fulfilled by reading this chapter
     */
    faoTitle?: string;

    /**
     * indicates if chapter "node" should be hidden in frontend - used for repetitorium
     */
    hidden?: boolean
}

export function isChapter(value: unknown): value is Chapter {
    return (
        typeof value === 'object' &&
        value !== null &&
        'sections' in value &&
        Array.isArray(value['sections']) &&
        !('id' in value)
    );
}
